import React, { useState } from 'react';

// One card with a top-right tab bar that switches between two embedded dashboard
// charts (e.g. Appointments ↔ Revenue). Children must be rendered with the
// `embedded` prop so they drop their own card chrome + heading.
//   tabs = [{ id, label, render: () => <Chart embedded ... /> }, ...]
const DashboardTabCard = ({ tabs = [], title }) => {
  const [active, setActive] = useState(tabs[0]?.id);
  const current = tabs.find((tb) => tb.id === active) || tabs[0];

  return (
    <div data-testid="dashboard-tab-card" className="bg-white w-full rounded-xl p-4 border border-gray-200/50 shadow-md">
      <div className={`flex items-center gap-3 mb-3 ${title ? 'justify-between' : 'justify-end'}`}>
        {title && <h3 className="text-base sm:text-lg font-bold text-gray-900 truncate">{title}</h3>}
        <div className="inline-flex bg-gray-100 rounded-lg p-1 shrink-0" data-testid="dashboard-tab-card-tabs">
          {tabs.map((tb) => (
            <button
              key={tb.id}
              type="button"
              onClick={() => setActive(tb.id)}
              data-testid={`dashboard-tab-${tb.id}`}
              className={`px-3 py-1.5 text-xs sm:text-sm font-semibold rounded-md transition-colors ${
                active === tb.id ? 'bg-white text-[#2D8A8A] shadow-sm' : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {tb.label}
            </button>
          ))}
        </div>
      </div>
      {current?.render?.()}
    </div>
  );
};

export default DashboardTabCard;
